export default function () {
    /**
     *  Scroll handling
     */
    const headerNavbar = document.querySelector('.header .navbar');
    let lastScrollTop = 0;
    const isScrollingDown = () => {
        let goingDown = false;
        let st = window.scrollY || document.documentElement.scrollTop;
        goingDown = st > lastScrollTop;
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
        return goingDown;
    };

    const handleScroll = () => {
        if (isScrollingDown()) {
            document.body.classList.remove("scroll-up");
            document.body.classList.add("scroll-down");
        } else {
            document.body.classList.add("scroll-up");
            document.body.classList.remove("scroll-down");
            headerNavbar.classList.remove('navbar-dark');
        }
        if (window.scrollY < 100) {
            document.body.classList.remove("scroll-up");
            if (headerNavbar.parentElement.classList.contains('has-navbar-dark')) {
                headerNavbar.classList.add('navbar-dark');
            }
        }
    };
    window.addEventListener("scroll", handleScroll);
}
